import(/* webpackMode: "eager" */ "/vercel/path0/src/app/create-e-card/page.tsx");
